// Formatages de la page "Usage des vues" (BI-693). Logique pure, sans React.
const VIDE = "—";
const nul = (v) => v === null || v === undefined || v === "" || isNaN(Number(v));
const fr = (n, d = 0) => n.toLocaleString("fr-FR", { maximumFractionDigits: d });

export function formaterNombre(v) {
  return nul(v) ? VIDE : fr(Number(v));
}

// ms -> "845 ms" ; au-dela de 1000 -> secondes ("4,1 s").
export function formaterDureeMs(v) {
  if (nul(v)) return VIDE;
  const n = Number(v);
  return n >= 1000 ? `${fr(n / 1000, 1)} s` : `${fr(Math.round(n))} ms`;
}

// octets -> o / Ko / Mo (base 1024).
export function formaterOctets(v) {
  if (nul(v)) return VIDE;
  const n = Number(v);
  if (n >= 1048576) return `${fr(n / 1048576, 1)} Mo`;
  if (n >= 1024) return `${fr(n / 1024, 1)} Ko`;
  return `${fr(n)} o`;
}

export function formaterDate(v) {
  if (!v) return VIDE;
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(String(v));
  if (!m) return VIDE;
  return `${m[3]}/${m[2]}/${m[1]}${m[4] ? ` ${m[4]}:${m[5]}` : ""}`;
}

// Tri tolerant aux null (en tete en ordre croissant, donc en fin en decroissant).
export const comparer = (cle) => (a, b) => {
  const x = a[cle];
  const y = b[cle];
  if (x === null || x === undefined) return y === null || y === undefined ? 0 : -1;
  if (y === null || y === undefined) return 1;
  return typeof x === "string" ? x.localeCompare(y, "fr") : x - y;
};

export const cleEnv = (hostname, code) => `${hostname}||${code}`;
export const lireEnv = (cle) => {
  const i = String(cle).indexOf("||");
  return { hostname: cle.slice(0, i), environnement_code: cle.slice(i + 2) };
};

// Lien vers Configuration > Referentiels > Vues (pre-filtre module si un filtre module est actif).
export const urlReferentiel = (module) => `/settings?tab=referentiels&sub=views${module ? `&module=${encodeURIComponent(module)}` : ""}`;

// « Referentiel synchronise le JJ/MM/AAAA HH:MM · <sha 8> » (meme texte dans Usage et Configuration).
export const texteSynchro = (sync) =>
  `Référentiel synchronisé le ${formaterDate(sync && sync.synced_at)}${sync && sync.last_commit_sha ? ` · ${String(sync.last_commit_sha).slice(0, 8)}` : ""}`;
